import React from 'react'
import {useSession} from '../lib'
import {useLocation} from 'wouter'
import {ErrorReport} from './Errors'
import {PageRouter} from './PageRouter'
import StartPage from '../pages/Start'
import SignOutPage from '../pages/SignOut'
import EmailsPage from '../pages/Emails'
import TeamPage from '../pages/Team'
import DebugPage from '../pages/Debug'
import GlobePage from '../pages/Globe'
import TripMapPage from '../pages/TripMap'
import AclsPage from '../pages/Acls'
import {AddTrip, DeleteTrip, ExportTrip, ImportTrip, PrivateTripFotos, ShareTrip, TripSummaryPanel, UpdateTrip} from './Trip'
import {ViewProfile, TeamSettings} from './Team'
import {DeleteFoto, UpdateFoto} from './Fotos'
import {AddMember, DeleteMember, ViewMember, UpdateMember} from './Team'
import {AddAcl, DeleteAcl, UpdateAcl, ViewAcl} from './Acl'
import {About} from './Help'
import {AppToaster, DetailPanel, SelectUser} from '.'
import {
  IconHome,
  IconAbout,
  IconAccess,
  IconSignOut,
  IconMsgsNotRead,
  IconTeamMembers,
  IconProfile,
  IconSettings,
  IconTrip,
} from '../Icons'
import {AppBar, Avatar, Box, Button, Container, Divider, Link, Menu, MenuItem, Toolbar} from '@mui/material'
import TripListPage from '../pages/TripList'

// TODO: yuno make this a panel instead?
function AppMenu() {
  const session = useSession()
  const [userLink, setUserLink] = React.useState<null | HTMLElement>(null)
  const openUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setUserLink(event.currentTarget)
  }
  const closeUserMenu = () => setUserLink(null)

  return (
    <AppBar position="static">
      <Container maxWidth="md">
        <Toolbar id="header" disableGutters sx={{display: 'flex', alignItems: 'center'}}>
          <Box position="relative" pb="10px">
            <Link href="/">
              <img
                src="https://tfks.sfo3.digitaloceanspaces.com/fotolog/img/logo.png"
                alt="logo"
                height="33"
                className="app-clickable"
              />
            </Link>
            <Box
              position="absolute"
              right={0}
              bottom={0}
              color="common.white"
              fontWeight={700}
              sx={{fontVariant: 'all-small-caps'}}
            >
              <span role="img">❤</span> &nbsp; tfks
            </Box>
          </Box>

          <Box ml="auto">
            <Button color="inherit" onClick={openUserMenu} sx={{p: 0}}>
              <Box display="flex" flexWrap="wrap" alignItems="center" justifyContent="end" ml={2}>
                {session.isManaging() ? 'Managing' : 'Hello'}
                <Box color="secondary.main" fontSize="0.8rem">
                  &nbsp; {session.scope.name}
                </Box>
              </Box>
              <Avatar
                alt={session.scope.name}
                src={session.scope.avatar}
                sx={{ml: 1, width: 50, height: 50, boxShadow: '4px 2px 6px #eee'}}
              />
            </Button>
            <Menu
              onClick={closeUserMenu}
              id="menu-appbar"
              anchorEl={userLink}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              keepMounted
              open={Boolean(userLink)}
              onClose={closeUserMenu}
            >
              <MenuItem>
                <Button href="/">
                  <IconHome /> &nbsp; Home
                </Button>
              </MenuItem>
              <MenuItem>
                <Button href="/trips">
                  <IconTrip /> &nbsp; Trips
                </Button>
              </MenuItem>
              {session.scope.isTeamLead && (
                <MenuItem>
                  <Button href="/team">
                    <IconTeamMembers /> &nbsp; Team
                  </Button>
                </MenuItem>
              )}
              <MenuItem>
                <Button href="/acl">
                  <IconAccess /> &nbsp; Access
                </Button>
              </MenuItem>
              <Divider />
              {(session.scope.isTeamLead || session.isAdmin) && (
                <MenuItem>
                  <Button href="./manage-user">
                    <IconProfile /> &nbsp; Manage
                  </Button>
                </MenuItem>
              )}
              <MenuItem>
                <Button href={`./view-profile`}>
                  <IconSettings /> &nbsp; Profile
                </Button>
              </MenuItem>
              <MenuItem>
                <Button href={`/email`}>
                  <IconMsgsNotRead /> &nbsp; Email
                </Button>
              </MenuItem>
              <Divider />
              <MenuItem>
                <Button href="./about">
                  <IconAbout /> &nbsp; About
                </Button>
              </MenuItem>
              <MenuItem>
                <Button href="/signout">
                  <IconSignOut /> &nbsp; Sign Out
                </Button>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

// TODO: maybe don't need my own router any more?
// - https://github.com/molefrog/wouter/releases/tag/v3.0.0

export default function PrivateApp() {
  const [location] = useLocation()
  return (
    <div id="main" className="private">
      <AppToaster />
      <AppMenu />
      <Box id="body" position="relative">
        <ErrorReport location={location}>
          <PageRouter
            routes={[
              {path: /^\/$/, page: StartPage, id: () => 'Home', fallback: true},
              {path: /^\/globe/, page: GlobePage, id: () => 'Globe'},
              {path: /^\/trips/, page: TripListPage, id: () => 'Trip List'},
              {
                path: /^\/trip\/(?<id>\d+)(-(?<slug>[-\w]+))?/,
                page: TripMapPage,
                id: ({id, slug}) => `Trip : ${slug || id}`,
              },
              {path: /^\/signout/, page: SignOutPage, id: () => 'Sign Out'},
              {path: /^\/email/, page: EmailsPage, id: () => 'Email'},
              {path: /^\/acl/, page: AclsPage, id: () => 'Access Rules'},
              {path: /^\/team/, page: TeamPage, id: () => 'Team'},
              {path: /^\/debug/, page: DebugPage, id: () => 'Debug Report'},
            ]}
          />
          <DetailPanel path="(?<home>.*)/add-trip" panel={AddTrip} title={['Add Trip']} />
          <DetailPanel path="(?<home>/globe)/import" panel={ImportTrip} title={['Import Trip']} />
          <DetailPanel
            path="(?<home>/trip/(?<trip>\d+)(-(?<slug>[-\w]+))?)/(?<foto>\d+)?$"
            panel={PrivateTripFotos}
            title={({slug}) => ['Trip', slug, 'Details']}
            overlay={false}
          />
          <DetailPanel
            path="(?<home>/trips)/(?<id>\d+)(-(?<slug>[-\w]+))?/$"
            panel={TripSummaryPanel}
            title={({slug}) => ['Trip', slug, 'Summary']}
          />
          <DetailPanel
            path="(?<home>/trips?/(?<id>\d+)(-(?<slug>[-\w]+))?)/update"
            panel={UpdateTrip}
            title={({slug}) => ['Trip', slug, 'Update']}
          />
          <DetailPanel
            path="(?<home>/trips?/(?<id>\d+)(-(?<slug>[-\w]+))?)/export"
            panel={ExportTrip}
            title={({slug}) => ['Trip', slug, 'Export']}
          />
          <DetailPanel
            path="(?<home>/trips?/(?<id>\d+)(-(?<slug>[-\w]+))?)/share"
            panel={ShareTrip}
            title={({slug}) => ['Trip', slug, 'Share']}
          />
          <DetailPanel
            path="(?<home>/trips?)/(?<id>\d+)(-(?<slug>[-\w]+))?/delete"
            panel={DeleteTrip}
            title={({slug}) => ['Trip', slug, 'Delete']}
          />
          <DetailPanel
            path="(?<home>/trips?/(?<trip>\d+)(-(?<slug>[-\w]+))?)/(?<foto>\d+)/update"
            panel={UpdateFoto}
            title={({slug, id}) => ['Trip', slug, `Foto ${id}`, 'Update']}
            overlay={false}
          />
          <DetailPanel
            path="(?<home>/trip/(?<trip>\d+)(-(?<slug>[-\w]+))?)/(?<foto>\d+)/delete"
            panel={DeleteFoto}
            title={({slug, id}) => ['Trip', slug, `Foto ${id}`, 'Delete']}
          />
          <DetailPanel path="(?<home>/acl)/add" panel={AddAcl} title={['Access Rules', 'Add']} />
          <DetailPanel path="(?<home>/acl)/(?<id>\d+)/view" panel={ViewAcl} title={({id}) => ['Access Rules', id, 'Details']} />
          <DetailPanel path="(?<home>/acl)/(?<id>\d+)/update" panel={UpdateAcl} title={({id}) => ['Access Rules', id, 'Update']} />
          <DetailPanel path="(?<home>/acl)/(?<id>\d+)/delete" panel={DeleteAcl} title={({id}) => ['Access Rules', id, 'Delete']} />
          <DetailPanel path="(?<home>.*)/manage-user" panel={SelectUser} title={['Manage User']} />
          <DetailPanel path="(?<home>/team)/settings" panel={TeamSettings} title={['Team', 'Settings']} />
          <DetailPanel path="(?<home>/team)/member/add" panel={AddMember} title={['Team', 'Add Member']} />
          <DetailPanel path="(?<home>/team)/member/(?<id>\d+)/view" panel={ViewMember} title={({id}) => ['Team', id, 'Member Details']} />
          <DetailPanel
            path="(?<home>.*)/member/(?<id>\d+)/update"
            panel={UpdateMember}
            title={({id}) => ['Team', id, 'Update Member']}
          />
          <DetailPanel
            path="(?<home>.*)/member/(?<id>\d+)/delete"
            panel={DeleteMember}
            title={({id}) => ['Team', id, 'Delete Member']}
          />
          <DetailPanel path="(?<home>.*)/update-profile" panel={UpdateMember} title={['Update Profile']} />
          <DetailPanel path="(?<home>.*)/view-profile" panel={ViewProfile} title={['View Profile']} />
          <DetailPanel path="(?<home>.*)/about" panel={About} title={['About FotoLog']} />
        </ErrorReport>
      </Box>
    </div>
  )
}
